import { inject, Pipe, PipeTransform } from '@angular/core';
import { CurrencyPipe } from '@angular/common';

@Pipe({
  name: 'formattedCurrency',
  pure: true
})
export class FormattedCurrencyPipe implements PipeTransform {
  private currencyPipe = inject(CurrencyPipe); // Inject using `inject()`

  transform(
    rawValue?: string | number | undefined,
    minorUnit: number = 2,
    ...args: any[]
  ): unknown {
    if (rawValue == null) {
      return '';
    }

    if (args[0] == null) {
      args[0] = 'USD';
    }

    if (args[1] == null) {
      args[1] = '$';
    }

    if (args[2] == null) {
      args[2] = '.2';
    }

    const value: number = parseFloat(rawValue.toString()) / 10 ** minorUnit;
    return this.currencyPipe.transform(value, ...args);
  }
}
